export default __webpack_public_path__ + "static/media/defaultTeamLogo.d93b3dff.jpg";